import React, { Component } from 'react';
import { Query } from 'react-apollo';
import './styles.scss';
import AdminGamesManager from '../AdminGamesManager';
import gql from 'graphql-tag';

const SESSION_GAMES_QUERY = gql`
	query sessionGamesQuery($sessionID: ID!, $page: Int, $coordinator: Boolean) {
		user {
			id
			session(sessionID: $sessionID) {
				id
				paginatedGames(page: $page, coordinator: $coordinator) {
					id
					edges {
						id
						data
						ignoreExpiration
						session {
							id
							name
						}
						player {
							id
							username
							password
							firstName
							lastName
							roles
						}
					}
					paginationInfo {
						id
						currentPage
						pageCount
					}
				}
			}
		}
	}
`;
class AdminGames extends Component {
	constructor(props) {
		super(props);

		this.state = {
			gamePage: 1,
			gameCoordinator: false
		};
	}
	render() {
		const { gamePage, gameCoordinator } = this.state;
		return (
			<Query
				query={SESSION_GAMES_QUERY}
				fetchPolicy={'cache-and-network'}
				variables={{
					page: gamePage,
					coordinator: gameCoordinator,
					sessionID: this.props.sessionID
				}}>
				{({ data, refetch }) => {
					if (!data.user) {
						return null;
					}
					const { session } = data.user;
					const { paginatedGames } = session;
					return (
						<div className="AdminGames">
							<AdminGamesManager
								{...this.props}
								refetch={refetch}
								paginatedGames={paginatedGames}
								coordinator={gameCoordinator}
								setQueryState={state => this.setState(state)}
								page={gamePage}
								sessionID={this.props.sessionID}
								showSessionsSelect={false}
							/>
						</div>
					);
				}}
			</Query>
		);
	}
}

export default AdminGames;
